import { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';

const faqs = [
  {
    question: 'Sistem nasıl çalışıyor?',
    answer: 'Girdiğiniz adres verilerini uydu sağlayıcılarımızdan aldığımız yüksek çözünürlüklü görsellerle eşleştirip, yapay zeka algoritmalarımızla hareketlendiriyoruz. Sonuç olarak sinematik bir tanıtım videosu elde ediyorsunuz.',
  },
  {
    question: 'Fiyatlar neden bu kadar uygun?',
    answer: 'Geleneksel drone çekimleri operasyonel maliyet (drone pilotu, seyahat, ekipman) gerektirirken, biz uydu verilerini dijital ortamda işlediğimiz için maliyetleri %90 oranında düşürüyoruz. Bu tasarrufu müşterilerimize yansıtıyoruz.',
  },
  {
    question: 'Hangi bölgeler için video hazırlayabilirim?',
    answer: 'Maplio, dünya genelindeki tüm bölgeler için kapsama alanına sahiptir. Şehir merkezlerinden en uzak arazilere kadar her yer için uydu görüntüsü tabanlı video oluşturabilirsiniz.',
  },
  {
    question: 'Videolar ne kadar sürede hazır oluyor?',
    answer: 'Ortalama işlem süresi 3-5 dakikadır. Yoğunluğa bağlı olarak bu süre değişebilir, ancak Profesyonel ve Kurumsal paketlerde öncelikli işlem hakkınız bulunur.',
  },
  {
    question: 'Hangi formatlarda video indirebilirim?',
    answer: 'Videolarınızı MP4 formatında, 1080p veya 4K çözünürlükte, yatay (16:9) veya dikey (9:16) formatlarda indirebilirsiniz. Tüm platformlarla uyumludur.',
  },
  {
    question: 'Videolara kendi logomu ekleyebilir miyim?',
    answer: 'Evet! Profesyonel ve Kurumsal paketlerde watermark/özel logo ekleme özelliği mevcuttur. Başlangıç paketinde Maplio logosu küçük bir şekilde görünür.',
  },
  {
    question: 'Para iade garantisi var mı?',
    answer: 'Evet, ilk 14 gün içinde memnun kalmazsanız koşulsuz para iadesi yapıyoruz. Ayrıca her ay paketinizi yükseltebilir veya düşürebilirsiniz.',
  },
  {
    question: 'API erişimi nedir? Kendi sistemime entegre edebilir miyim?',
    answer: 'Kurumsal paketimizde REST API erişimi sunuyoruz. Bu sayede kendi CRM, web sitesi veya uygulamanıza Maplio video üretimini entegre edebilirsiniz.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="section-padding bg-slate-50 dark:bg-slate-900/50">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full 
                            bg-primary/10 text-primary text-sm font-semibold mb-4">
              <HelpCircle className="w-4 h-4" />
              SSS
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4 text-slate-900 dark:text-white">
              Sıkça Sorulan <span className="gradient-text">Sorular</span>
            </h2>
            <p className="text-slate-600 dark:text-slate-400">
              Aklınıza takılan soruların cevaplarını burada bulabilirsiniz.
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white dark:bg-slate-800 rounded-2xl shadow-sm 
                           border border-slate-100 dark:border-slate-700 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                  className="w-full flex items-center justify-between p-6 text-left 
                             hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors"
                  aria-expanded={openIndex === index}
                >
                  <span className="font-bold text-slate-900 dark:text-white pr-4">
                    {faq.question}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-primary flex-shrink-0 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <p className="px-6 pb-6 text-slate-500 dark:text-slate-400 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
